import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-filter",
  templateUrl: "./med-icon-filter.component.html",
})
export class MedIconFilterComponent extends SvgMixinComponent {}
